import React, { Component } from "react";

class TutorLearnMore extends Component {
  render() {
    return (
      <div className="flex-center-center" style={{ height: "500px" }}>
        <h3>tutor Learn More..</h3>
      </div>
    );
  }
}

export default TutorLearnMore;
